import React from 'react';
import { StyledModalFooterContainer } from './modal-footer.styled';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * ModalFooterSlot component.
 *
 * @author Mikhail Siutsou
 * @function ModalFooter
 * @category components
 * @param {ModalFooterProps} content props.
 * @return {JSX.Element} ModalFooterSlot component.
 */
var ModalFooter = function ModalFooter(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx(StyledModalFooterContainer, {
    children: children
  });
};

ModalFooter.displayName = 'ModalFooter';
export { ModalFooter };